import React from 'react';
export interface CardProps {
  children: React.ReactNode;
  className?: string;
  glowing?: boolean;
}
export function Card({
  children,
  className = '',
  glowing = false
}: CardProps) {
  const glowClass = glowing ? 'border-[#00D4FF]/40 shadow-[0_0_20px_rgba(0,212,255,0.2)]' : 'border-[#00D4FF]/20';
  return <div className={`bg-white/5 backdrop-blur-sm border ${glowClass} rounded-2xl p-8 ${className}`} data-id="element-2">
      {children}
    </div>;
}